import { flatAdvanceForm } from "../../../helpers/advance-form.helper";
const fmisForm = {
  memo_ref: [],
  DepartmentCode: "", // ดึงจาก Login
  fixError: false, // กรณีที่เป็นการแก้ไขใบเดิม ส่ง true ถ้าสร้างใบใหม่ ใส่ false
  errorNumOfFile: 0, // จำนวนครั้งที่แก้ error ไฟล์นั้น
  errorFileName: "", // ชื่อไฟล์ดดิม ถ้าเป็นสร้างใบใหม่ ส่ง ""
  HeaderList: [
    {
      HeaderNo: "1", //ใส่ 1
      SourceDate: "", // วันที่สร้าง
      BudGetYear: "", // กรณีที่ส่งเข้ามาจกใช้ปีงบประมาณของปีนั้น ถ้าไม่ส่ง จะดึงจากระบบ
      Doc_to: "", // ไม่ต้องส่ง
      Department_Code: "", // ดึงจาก Login,
      RegionCode: "", // ไม่ต้องส่ง
      CreateUserPP: "", // userpriceiple
      DocPerCode: "", //ไม่ต้องส่ง
      Sign1PerCode: "", // Code จาก Field หน้าจอ ผู้ตรวจก่อนอนุมัติจ่าย
      ApprovePerCodePP: "", // Code จาก Field หน้าจอ ผู้อนุมัติงบใบสำคัญ
      ApprovePerCodeBG: "", // Code จาก Field หน้าจอ ผู้อนุมัติเบิกจ่ายงบประมาณ
      IsBudget: "ํ", // "ประเภทเงินที่ใช้ เงินในงบ Y:N"
      IsBudgetOut: "", // "ประเภทเงินที่ใช้ เงินนอกงบ Y:N"
      DrawJobType: "", //ไม่ต้องส่ง
      DocSubject: "", //ไม่ต้องส่ง
      DocBody: "", //ไม่ต้องส่ง
      RequestReason: "", //ไม่ต้องส่ง
      VendorName: "", // จาก Field หน้าจอ ชื่อผู้ค้า
      DueDate: "", // Code จาก Field หน้าจอ วันครบกำหนดชำระ
      TypeOfPP: "", // Code จาก Field หน้าจอ
      NumberOfPP: "", //ไม่ต้องส่ง
      ReferenceNo: "", // Code จาก Field หน้าจอ
      DeductAmount: 0.0,
      DetailSet: [
        {
          DetailNo: "1", // หมายเลข Row ในหน้าจอ ส่วน table ด้านล่าง
          InvoiceType: "", // จาก Field หน้าจอ ประเภทใบสำคัญ (ส่ง Text ใน DDL มาได้เลย หลังบ้านทำ Maping ไว้แล้ว)
          InvoiceNo: "", // จาก Field หน้าจอ หมายเลข
          GroupName: "sample string 4", // ชื่อหมวดหมู่
          BgItemNo: "", // เลขที่รายการ
          PlanCode: "sample string 5",
          PlanName: "", //ไม่ต้องส่ง
          SourceOfFund: "sample string 7",
          SourceOfFundSub: "sample string 8",
          BankAccountCode: "",
          VenderNameFMIS: "sample string 10", // จาก Field หน้าจอ ชื่อผู้ค้า
          Amount: 0.0, // จาก Field หน้าจอในตารางด้านล่าง
          PayeeType: "1",
          PayeeCode: "", // จาก Field หน้าจอ ชื่อผู้ค้า
          VatRate: "", // จาก Field หน้าจอ Vat
        },
        {
          DetailNo: "2", // หมายเลข Row ในหน้าจอ ส่วน table ด้านล่าง
          InvoiceType: "", // จาก Field หน้าจอ ประเภทใบสำคัญ (ส่ง Text ใน DDL มาได้เลย หลังบ้านทำ Maping ไว้แล้ว)
          InvoiceNo: "", // จาก Field หน้าจอ หมายเลข
          GroupName: "sample string 4", // ชื่อหมวดหมู่
          BgItemNo: "", // เลขที่รายการ
          PlanCode: "sample string 5",
          PlanName: "", //ไม่ต้องส่ง
          SourceOfFund: "", // จาก Field หน้าจอ หมายเลขรหัสแหล่งเงิน
          SourceOfFundSub: "", // จาก Field หน้าจอ หมายเลขรหัสแหล่งเงินย่อย ถ้ามี
          BankAccountCode: "", // จาก Field หน้าจอ หมายเลขรหัสลบัญชี
          VenderNameFMIS: "sample string 10", // จาก Field หน้าจอ ชื่อผู้ค้า
          Amount: 11.0, // จาก Field หน้าจอในตารางด้านล่าง
          PayeeType: "1",
          PayeeCode: "", // จาก Field หน้าจอ ชื่อผู้ค้า
          VatRate: "", // จาก Field หน้าจอ Vat
        },
      ],
    },
  ],
};

export function useForm27TransformToFMIS() {
  const templateId = [27, 67];
  enum TABLE_NAME {
    A = "รายการสินค้า",
    B = "ข้อมูลใบวางบิลสำหรับใช้ออกงบใบสำคัญ",
  }

  function getValueFromFlatForm(label: string, flatForm: any[]): string {
    return (
      flatForm
        .filter(
          (item) =>
            item &&
            item.template &&
            !["em", "l"].includes(item.template.type ?? "")
        )
        .find((item) => item.template.label === label)?.data?.value ?? ""
    );
  }

  function mapDetailSet(vendorName: string, flatForm: any[]): any[] {
    const control = flatForm.find(
      (item) =>
        item &&
        item.template &&
        item.template.type === "tb" &&
        item.template.label === "ข้อมูลใบวางบิลสำหรับใช้ออกงบใบสำคัญ"
    );
    const invoiceType = flatForm.find((invType) => {
      return (invType?.template?.type === 'dd' && invType?.template?.label === 'ประเภทใบสำคัญ')
    })
    const invoiceNo = flatForm.find((invType) => {
      return (invType?.template?.type === 't' && invType?.template?.label === 'เลขที่ใบสำคัญ')
    })
    const detailSet = control?.data?.row?.map((row: any) =>
      row.reduce((acc: any, cur: any, curIndex: number) => {
        const columns = control.template.attribute?.column ?? [];
        let column = columns[curIndex] ?? {};
        return { ...acc, [column.label]: cur.value };
      }, {} as any)
    );

    return (
      detailSet?.map((item: any, index: number) => {

        // ฟังก์ชันดึงรหัสแรก (รหัสบัญชีย่อย)
        const extractCode = (fieldValue: any, removeParentheses: boolean = false): string => {
          const value = fieldValue ?? "";
          let cleanedValue = value.replace(/[\r\n]/g, ' ').trim();
          let parts = cleanedValue.split(" ");

          if (removeParentheses) {
              parts = parts.map((s: string) => s.replace(/\(|\)/g, "")); // ลบวงเล็บออก ถ้าค่าเป็น true
          }

          return parts[0] ?? "";
        };
        
        const planCode = ((item["แผนงาน"] ?? "")
          .split(" ")
          ?.map((s: string) => s.replace(/\(|\)/g, "")) ?? [""])[0];
        const bankAccountCode = ((item["รหัสบัญชี"] ?? "")
          .split(" ")
          ?.map((s: string) => s.replace(/\(|\)/g, "")) ?? [""])[0];
        
        const sourceOfFundCode = extractCode(item["รหัสแหล่งเงิน"]);
        let sourceOfFundSubCode = extractCode(item["รหัสบัญชีย่อย"]);
        const subCodeValue = item["รหัสบัญชีย่อย"];

        // ตรวจสอบ subCodeValue
        if (subCodeValue === "-- Please Select --" || subCodeValue === "--select--") {
          sourceOfFundSubCode = "";
        }

        return {
          DetailNo: `${index + 1}`,
          InvoiceType: invoiceType?.data?.value,
          InvoiceNo: invoiceNo?.data?.value,
          GroupName: item["หมวดวัสดุ"],
          BgItemNo: item["เลขที่รายการ"],
          PlanCode: planCode,
          // PlanName: "",
          SourceOfFund: sourceOfFundCode,
          SourceOfFundSub: sourceOfFundSubCode,
          BankAccountCode: bankAccountCode,
          VenderNameFMIS: vendorName,
          Amount: item["จำนวนเงิน"],
          PayeeType: "1",
          PayeeCode: vendorName,
          VatRate: item["อัตราภาษี"],
        };
      }) ?? []
    );
  }

  function transform(formData: any[]) {
    const flatForm = flatAdvanceForm(formData);
    const employeeData = JSON.parse(
      localStorage.getItem("userData") || "{}"
    ).employeeData;

    // get from login profile
    // ["Department_Code, Department_Code"],
    // ["CreateUserPP, CreateUserPP"],

    const productListControl = flatForm.find(
      (item) =>
        item &&
        item.template &&
        item.template.type === "tb" &&
        item.template.label === TABLE_NAME.A,
    );
    // const vendorName = (productListControl?.custom as any)?.vendorName ?? "";

    const vendorName =
      (productListControl?.custom as any)?.vendorName ||
      productListControl?.data?.row?.[0]?.[0]?.value ||
      "";

    // console.log("productListControl:", productListControl);
    // console.log("custom:", productListControl?.custom);
    // console.log("vendorName:", vendorName);
    // console.log("flatForm:", flatForm,formData);
    // console.log("value-value",productListControl?.data?.row?.[0]?.[0]?.value)

    const headerList: {
      fmisKey: string;
      formKey: string;
      map?: (value: string, formKey: string, fmisKey: string) => any;
    }[] = [
        {
          fmisKey: "Doc_to",
          formKey: "เรียน",
        },
        {
          fmisKey: "DocSubject",
          formKey: "เรื่อง",
        },
        {
          fmisKey: "DocBody",
          formKey: "เนื้อหาสำคัญ",
        },
        {
          fmisKey: "CreateUserPP",
          formKey: "CreateUserPP",
          map: () => employeeData?.Username,
        },
        {
          fmisKey: "RegionCode",
          formKey: "จังหวัด"
        },
        {
          fmisKey: "Department_Code",
          formKey: "Department_Code",
          map: () => employeeData?.DepartmentCode,
        },
        { fmisKey: "BudGetYear", formKey: "ปีงบประมาณ" },
        {
          fmisKey: "Sign1PerCode",
          formKey: "ผู้ตรวจก่อนอนุมัติจ่าย",
          map: (value: string) => ((value ?? "").split(" ") ?? [""])[0],
        },
        {
          fmisKey: "ApprovePerCodePP",
          formKey: "ผู้อนุมัติงบใบสำคัญ",
          map: (value: string) => ((value ?? "").split(" ") ?? [""])[0],
        },
        {
          fmisKey: "ApprovePerCodeBG",
          formKey: "ผู้อนุมัติเบิกจ่ายงบประมาณ",
          map: (value: string) => ((value ?? "").split(" ") ?? [""])[0],
        },
        {
          fmisKey: "IsBudget",
          formKey: "ประเภทเงินที่ใช้",
          map: (value: string) => (value === "เงินงบประมาณ" ? "Y" : "N"),
        },
        {
          fmisKey: "IsBudgetOut",
          formKey: "ประเภทเงินที่ใช้",
          map: (value: string) =>
            value === "เงินนอกงานงบประมาณ/เงินงบประมาณเหล่ากาชาด" ? "Y" : "N",
        },
        {
          fmisKey: "VendorName",
          formKey: "ชื่อผู้ประกอบการ",
          map: () => vendorName,
        },
        { fmisKey: "DeductAmount", formKey: "ค่าปรับ" },
        { fmisKey: "DueDate", formKey: "วันที่ครบกำหนดชำระ" },
        {
          fmisKey: "DetailSet",
          formKey: "DetailSet",
          map: () => mapDetailSet(vendorName, flatForm),
        },
      ];

    let result: any = {
      ...fmisForm,
      DepartmentCode: employeeData?.DepartmentCode,
    };
    headerList.forEach((item) => {
      const value = getValueFromFlatForm(item.formKey, flatForm);
      result.HeaderList[0][item.fmisKey] = item.map
        ? item.map(value, item.formKey, item.fmisKey)
        : value;
    });
    return result;
  }

  return { templateId, transform };
}
